import React from 'react';
import PropTypes from 'prop-types';

import colors from 'theme/_colors.scss';

const IconBearingBPFI = ({ width = 16, height = 16, viewBox = '0 0 16 16', color = colors.black }) => {
    return <svg width={width} height={height} viewBox={viewBox} fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M9 1.33301L7 1.33301V0L9 0V1.33301ZM9 12H7V4H9V12ZM9 16H7V14.667H9V16Z' fill={color} />
    </svg>;
};

IconBearingBPFI.propTypes = {
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    viewBox: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default IconBearingBPFI;
